"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultGTMQuery = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const useSearchResultGTMQuery = (initialQuery, totalResultCount, lastUserAction, isSubsequentRef) => {
    const { results } = (0, react_instantsearch_1.useInstantSearch)();
    const previousQueryRef = React.useRef(initialQuery);
    const previousTotalResultCountRef = React.useRef(totalResultCount);
    React.useEffect(() => {
        const isDataNotLoaded = !(results === null || results === void 0 ? void 0 : results.exhaustive);
        const isNotQueryAction = lastUserAction.name !== app_1.LastUserActionNameEnum.Query &&
            lastUserAction.name !== app_1.LastUserActionNameEnum.Init;
        const queryUnchanged = lastUserAction.name !== app_1.LastUserActionNameEnum.Init &&
            previousQueryRef.current === results.query;
        const totalResultCountNotUpdated = previousTotalResultCountRef.current === totalResultCount;
        if (isDataNotLoaded || isNotQueryAction || queryUnchanged || totalResultCountNotUpdated) {
            return;
        }
        app_1.GTM.search({
            refinement: !isSubsequentRef.current,
            resultsCount: totalResultCount,
            searchQuery: results.query || '',
            sessionId: app_1.SessionService.GetSessionId(),
            suggestion: false,
        });
        previousQueryRef.current = results.query || '';
        previousTotalResultCountRef.current = totalResultCount;
        isSubsequentRef.current === false && (isSubsequentRef.current = true);
    }, [results, totalResultCount, lastUserAction]);
};
exports.useSearchResultGTMQuery = useSearchResultGTMQuery;
